import { inject } from 'aurelia';
import { IHttpClient } from '@aurelia/fetch-client';
import { ApiBase } from '../api-base';

export interface AssociationSummaryDto {
    id: string;
    name: string;
}

// Lists associations for a group regardless of whether any team currently references them
// (e.g. associations created via registration, or left over after all teams were removed).
@inject(IHttpClient)
export class GroupAssociationsApi extends ApiBase {
    constructor(http: IHttpClient) {
        super(http);
    }

    public async listByGroupId(eventId: string, groupId: string): Promise<AssociationSummaryDto[]> {
        const r = await this.get(`api/events/${eventId}/groups/${groupId}/associations`);
        return (r.content as AssociationSummaryDto[]) ?? [];
    }

    public async renameAssociation(eventId: string, groupId: string, associationId: string, name: string): Promise<void> {
        await this.patch(`api/events/${eventId}/groups/${groupId}/associations/${associationId}`, { name });
    }

    public async deleteAssociation(eventId: string, groupId: string, associationId: string): Promise<void> {
        await this.delete(`api/events/${eventId}/groups/${groupId}/associations/${associationId}`);
    }
}
